import React from 'react'
import { formattedText } from '../../services/Fonctions';

function Zambie({ data }) {
    const d = data[0];
    let fob = 0;
    let poids = 0;
    let cif = 0;
    let nbr = 0;
    data.forEach(dt => {
        fob += dt.invoice_amount;
        poids += dt.net_weight;
        cif += dt.invoice_amount + dt.external_freight + dt.insurrance;
        nbr++;
    });
    return (
        <div>
            <div className='card mb-3' >
                <div className='card-header'><b>Segment Général</b></div>
                <div className='card-body shadow' style={{ fontSize: '12px' }}>
                    <div className='row'>
                        <ItemCard label="Modele et Date" value={d.modele + "&emsp;" + d.registration_date} />
                        <ItemCard label="Identité et Nationalité Moyen de transport" value={d.mode_of_transport + "&emsp; (" + d.nationality_of_transport + ")"} />
                        <ItemCard label="Point d'entrée" value={d.transits_destination_office} />
                        <ItemCard label="Référence déclarant" value={d.declarant_tpin} />
                        <ItemCard label="Expediteur" value={d.exporter_name} />
                        <ItemCard label="Destination" value={d.destination} />
                        <ItemCard label="Nbre Articles" value={"" + nbr} />
                        <ItemCard label="Poids" value={"" + poids} />
                        <ItemCard label="FOB" value={"" + fob + "&emsp;" + d.currency} />
                        <ItemCard label="CIF" value={"" + cif + "&emsp;" + d.currency} />
                        <ItemCard label="Importateur" value={d.consignee_name} />

                    </div>
                </div>
            </div>
            <div className='row'>
                {data.map(d => {
                    return (
                        <div className=''>
                            <table className='table table-bordered table-striped' style={{ fontSize: '12px' }}>
                                <thead>
                                    <tr className='table-primary'>
                                        <th colSpan={5}>Article {d.item}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className=''>
                                        <td>
                                            <small><b>Position</b></small><br />
                                            {d.hs_code}
                                        </td>
                                        <td>
                                            <small><b>Libellé</b></small><br />
                                            {d.hs_description}
                                        </td>
                                        <td>
                                            <small><b>Origine</b></small><br />
                                            {d.origin}
                                        </td>
                                        <td>
                                            <small><b>Dévise</b></small><br />
                                            {d.currency}
                                        </td>
                                        <td>
                                            <small><b>Autre Info</b></small><br />
                                            {d.txt_fre}
                                        </td>
                                    </tr>

                                    <tr className=''>
                                        <td>
                                            <small><b>Poids Net</b></small><br />
                                            {d.net_weight}
                                        </td>
                                        <td>
                                            <small><b>Description Marchandise</b></small><br />
                                            {d.goods_description}
                                        </td>
                                        <td>
                                            <small><b>Facture</b></small><br />
                                            {d.invoice_amount}
                                        </td>
                                        <td>
                                            <small><b>Fret</b></small><br />
                                            {d.external_freight}
                                        </td>
                                        <td>
                                            <small><b>Assurance</b></small><br />
                                            {d.insurrance}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>)
                })}
            </div>
        </div>
    )
}

function ItemCard({ label, value }) {
    return <Item label={label} value={value} className="col-sm-4 cols-md-3 col-lg-2" />
}

function Item({ label, value, className }) {
    return (
        <div className={className}>
            <small><b>{label}</b></small><br />
            {value && <p dangerouslySetInnerHTML={{ __html: formattedText(value) }} />}

        </div>
    )
}

export default Zambie